import { BatchReports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreateBatchReportRequest = Simple({
  id: '85807fa7-5c65-4b86-8e23-ce17f47f1248',
  action: 'Create',
  object: 'Batch Report',
  page: BatchReports,
})
